import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Paper, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="80vh"
      p={2}
    >
      <Paper
        elevation={4}
        sx={{
          p: 5,
          maxWidth: 500,
          textAlign: 'center',
          borderRadius: 3,
        }}
      >
        <Box
          sx={{
            width: 70,
            height: 70,
            borderRadius: '50%',
            backgroundColor: '#ffebee',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px auto',
          }}
        >
          <LockOutlinedIcon sx={{ fontSize: 40, color: '#d32f2f' }} />
        </Box>

        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 700, color: '#333' }}>
          403 - Access Denied
        </Typography>

        <Typography variant="body1" sx={{ color: '#666', mb: 4, lineHeight: 1.6 }}>
          You do not have permission to access this page or module. If you believe this is an error, please contact your administrator.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => navigate('/Dashboard')}
          sx={{ px: 4, py: 1.2, textTransform: 'none', fontSize: '16px' }}
        >
          Back to Dashboard
        </Button>
      </Paper>
    </Box>
  );
};

export default Unauthorized;
